import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "tw-w-full tw-overflow-x-auto" }
const _hoisted_2 = { class: "tw-min-w-full tw-text-left tw-text-sm tw-table-fixed" }
const _hoisted_3 = { class: "tw-border-b tw-border-slate-200" }
const _hoisted_4 = {
  key: 0,
  class: "tw-whitespace-nowrap tw-px-3 tw-py-2 tw-font-semibold tw-text-slate-700 tw-w-56"
}
const _hoisted_5 = { class: "tw-align-top" }
const _hoisted_6 = { class: "tw-whitespace-nowrap tw-w-7 tw-px-2 tw-py-2 tw-text-slate-700" }
const _hoisted_7 = { class: "tw-w-32" }
const _hoisted_8 = {
  key: 0,
  class: "tw-px-1 tw-py-2 tw-w-32 dispatch-trip-edit-scheduled-date"
}
const _hoisted_9 = {
  key: 1,
  class: "tw-whitespace-nowrap tw-px-2 tw-py-2 tw-text-slate-700 tw-w-32"
}
const _hoisted_10 = {
  key: 2,
  class: "tw-px-1 tw-py-2 tw-w-56"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 4,
  class: "tw-px-3 tw-py-2 tw-text-slate-700 tw-w-56"
}
const _hoisted_13 = {
  key: 5,
  class: "tw-px-1 tw-py-2 tw-w-56"
}
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  key: 7,
  class: "tw-px-3 tw-py-2 tw-text-slate-700 tw-w-56"
}
const _hoisted_16 = {
  key: 8,
  class: "tw-w-56 tw-px-1 tw-py-2"
}
const _hoisted_17 = {
  key: 9,
  class: "tw-whitespace-nowrap tw-px-3 tw-py-2 tw-text-slate-700 tw-w-56"
}
const _hoisted_18 = {
  key: 10,
  class: "tw-px-1 tw-py-2 tw-w-36"
}
const _hoisted_19 = {
  key: 11,
  class: "tw-whitespace-nowrap tw-px-3 tw-py-2 tw-text-slate-700"
}
const _hoisted_20 = { class: "tw-whitespace-nowrap tw-px-0 tw-py-2" }
const _hoisted_21 = { class: "tw-flex tw-justify-end tw-items-center tw-gap-1" }
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = {
  key: 0,
  class: "tw-mr-2 tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-white/40 tw-border-t-white"
}
const _hoisted_24 = ["disabled", "onClick"]
const _hoisted_25 = {
  key: 0,
  class: "tw-mr-2 tw-h-4 tw-w-4 tw-animate-spin tw-rounded-full tw-border-2 tw-border-white/40 tw-border-t-white"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "tw-ml-1 tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-border tw-h-5 tw-min-w-[10px] tw-px-1.5 tw-text-[10px] tw-font-bold tw-bg-emerald-600 tw-text-white tw-border-emerald-600 tw-absolute",
  style: {"top":"-12px","right":"-12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContainerAddTripRow = _resolveComponent("ContainerAddTripRow")!
  const _component_TripTypeField = _resolveComponent("TripTypeField")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TripRowActionsMenu = _resolveComponent("TripRowActionsMenu")!
  const _component_AddNotesModal = _resolveComponent("AddNotesModal")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-2 tw-py-2 tw-font-semibold tw-text-slate-700 tw-w-7" }, "#", -1)),
            _cache[10] || (_cache[10] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2 tw-font-semibold tw-text-slate-700 tw-w-32" }, "Type", -1)),
            _cache[11] || (_cache[11] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-2 tw-py-2 tw-font-semibold tw-text-slate-700 tw-w-32" }, "Scheduled", -1)),
            _cache[12] || (_cache[12] = _createElementVNode("th", { class: "tw-px-3 tw-py-2 tw-font-semibold tw-text-slate-700 tw-w-56" }, "Origin", -1)),
            _cache[13] || (_cache[13] = _createElementVNode("th", { class: "tw-px-3 tw-py-2 tw-font-semibold tw-text-slate-700 tw-w-56" }, "Destination", -1)),
            (_ctx.showDriver)
              ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Driver"))
              : _createCommentVNode("", true),
            _cache[14] || (_cache[14] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2 tw-font-semibold tw-text-slate-700 tw-w-36" }, "Chassis", -1)),
            _cache[15] || (_cache[15] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-3 tw-py-2 tw-font-semibold tw-text-slate-700 tw-w-56" }, null, -1))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedTrips, (trip, tripIdx) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: trip.id
            }, [
              (
          _ctx.editable &&
          !_ctx.container.isCancelled &&
          _ctx.tripAdditionContainer === _ctx.container.id &&
          _ctx.editingTrip.beforeLegId == tripIdx
        )
                ? (_openBlock(), _createBlock(_component_ContainerAddTripRow, {
                    key: 0,
                    editingTrip: _ctx.editingTrip,
                    onConfirmAddTrip: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmAddTrip(_ctx.container, _ctx.order.id))),
                    onCancelTripAddition: _ctx.cancelTripAddition,
                    onAddChassisTag: _ctx.addChassisTag,
                    terminals: _ctx.terminals,
                    filterDrivers: _ctx.filterDrivers,
                    filteredChassis: _ctx.filteredChassis,
                    destinationCustomers: _ctx.destinationCustomers,
                    originCustomers: _ctx.originCustomers,
                    onOnOriginCustomerSearch: _ctx.onOriginCustomerSearch,
                    onOnDestinationCustomerSearch: _ctx.onDestinationCustomerSearch
                  }, null, 8, ["editingTrip", "onCancelTripAddition", "onAddChassisTag", "terminals", "filterDrivers", "filteredChassis", "destinationCustomers", "originCustomers", "onOnOriginCustomerSearch", "onOnDestinationCustomerSearch"]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", {
                class: _normalizeClass(["tw-border-b tw-border-slate-100 hover:tw-bg-slate-50/50", _ctx.editingTrip.id === trip.id ? 'tw-bg-indigo-50/40' : ''])
              }, [
                _createElementVNode("td", _hoisted_6, _toDisplayString(tripIdx), 1),
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(_component_TripTypeField, {
                    autofocus: "",
                    showLabel: false,
                    trip: _ctx.editingTrip.id === trip.id ? _ctx.editingTrip : trip,
                    isEditing: _ctx.editingTrip.id === trip.id,
                    darkGreen: trip.status == 'Complete',
                    gray: trip.status != 'Complete' && trip.status != 'In Progress',
                    green: trip.status == 'In Progress'
                  }, null, 8, ["trip", "isEditing", "darkGreen", "gray", "green"])
                ]),
                (_ctx.editingTrip.id === trip.id)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                      _createVNode(_component_DatePicker, {
                        class: "tw-block",
                        "input-class": 'tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55',
                        format: "MM/DD/YYYY",
                        modelValue: _ctx.editingTrip.scheduledDate,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingTrip.scheduledDate) = $event)),
                        "show-days-shortcuts": true,
                        "controls-placement": "popup"
                      }, null, 8, ["modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(trip.scheduledDate ? _ctx.formatDate(trip.scheduledDate) : '--'), 1)),
                (_ctx.editingTrip.id === trip.id)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                      _createVNode(_component_FilterableDropdown, {
                        showLabels: false,
                        placeholder: "Origin",
                        size: "sm",
                        modelValue: _ctx.editingTrip.origin,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editingTrip.origin) = $event)),
                        customLabel: (x) => (x.shortName ? x.shortName : x.name),
                        options: _ctx.combinedOriginOptions,
                        class: _normalizeClass(_ctx.caller === 'dispatch' ? 'tw-w-[180px]' : 'tw-w-[180px]'),
                        onSearchChange: _ctx.onOriginCustomerSearch
                      }, null, 8, ["modelValue", "customLabel", "options", "class", "onSearchChange"])
                    ]))
                  : (trip.origin)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 3,
                        title: _ctx.fullAddress(trip.origin.address),
                        class: "tw-px-3 tw-py-2 tw-text-slate-700 tw-w-56"
                      }, _toDisplayString(_ctx.nameForLocation(trip.origin)), 9, _hoisted_11))
                    : (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(_ctx.nameForLocation(trip.origin)), 1)),
                (_ctx.editingTrip.id === trip.id)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                      _createVNode(_component_FilterableDropdown, {
                        showLabels: false,
                        placeholder: "Destination",
                        size: "sm",
                        modelValue: _ctx.editingTrip.destination,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingTrip.destination) = $event)),
                        customLabel: (x) => (x.shortName ? x.shortName : x.name),
                        options: _ctx.combinedDestinationOptions,
                        class: _normalizeClass(_ctx.caller === 'dispatch' ? 'tw-w-[180px]' : 'tw-w-[180px]'),
                        onSearchChange: _ctx.onDestinationCustomerSearch
                      }, null, 8, ["modelValue", "customLabel", "options", "class", "onSearchChange"])
                    ]))
                  : (trip.destination)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 6,
                        title: _ctx.fullAddress(trip.destination.address),
                        class: "tw-px-3 tw-py-2 tw-text-slate-700 tw-w-56"
                      }, _toDisplayString(_ctx.nameForLocation(trip.destination)), 9, _hoisted_14))
                    : (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(_ctx.nameForLocation(trip.destination)), 1)),
                (_ctx.editingTrip.id === trip.id)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                      _createVNode(_component_FilterableDropdown, {
                        showLabels: false,
                        placeholder: "Driver",
                        size: "sm",
                        modelValue: _ctx.editingTrip.driver,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingTrip.driver) = $event)),
                        label: "fullName",
                        options: _ctx.filterDrivers
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : (_ctx.showDriver)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(trip.driver ? trip.driver.fullName : ''), 1))
                    : _createCommentVNode("", true),
                (_ctx.editingTrip.id === trip.id)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-px-2 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/15 focus:tw-border-indigo-500/55 tw-w-[100%]",
                        placeholder: "Chassis Number",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingTrip.chassis) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.editingTrip.chassis]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("td", _hoisted_19, [
                      _createVNode(_component_CopyButton, {
                        value: trip.chassis,
                        mode: "wrap-content",
                        title: "Copy chassis number",
                        "aria-label": "Copy chassis number to clipboard"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(trip.chassis), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ])),
                _createElementVNode("td", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (_ctx.editable && _ctx.editingTrip.id === trip.id)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_Button, {
                            isGreen: true,
                            class: "tw-h-9 tw-w-9 tw-p-0",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.saveTrip(_ctx.editingTrip)), ["stop"])),
                            enableLoading: _ctx.loading,
                            disabled: _ctx.loading,
                            title: "Save container details",
                            "aria-label": "Save container details",
                            icon: "check"
                          }, null, 8, ["enableLoading", "disabled"]),
                          _createVNode(_component_Button, {
                            isRed: true,
                            isSecondary: true,
                            class: "tw-h-9 tw-w-9 tw-p-0",
                            onClick: _ctx.cancelEditTrip,
                            disabled: _ctx.loading,
                            title: "Cancel edit container details",
                            "aria-label": "Cancel edit container details",
                            icon: "xmark"
                          }, null, 8, ["onClick", "disabled"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.editingTrip.id !== trip.id)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.isStartCandidate(trip))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-lg tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white", _ctx.canStartTrip(tripIdx)
                    ? 'tw-bg-emerald-600 hover:tw-bg-emerald-700'
                    : 'tw-bg-slate-300 tw-cursor-not-allowed']),
                                disabled: !_ctx.canStartTrip(tripIdx) || _ctx.isTripActionPending(trip.id),
                                onClick: _withModifiers(($event: any) => (_ctx.startTrip(trip, tripIdx)), ["stop"])
                              }, [
                                (_ctx.isTripActionPending(trip.id) && _ctx.actionLoadingType === 'start')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.isTripActionPending(trip.id) && _ctx.actionLoadingType === 'start' ? 'Starting...' : 'Start Trip'), 1)
                              ], 10, _hoisted_22))
                            : (_ctx.canCompleteTrip(tripIdx))
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "tw-inline-flex tw-items-center tw-rounded-lg tw-px-3 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-bg-rose-600 hover:tw-bg-rose-700",
                                  disabled: _ctx.isTripActionPending(trip.id),
                                  onClick: _withModifiers(($event: any) => (_ctx.completeTrip(trip, tripIdx)), ["stop"])
                                }, [
                                  (_ctx.isTripActionPending(trip.id) && _ctx.actionLoadingType === 'complete')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.isTripActionPending(trip.id) && _ctx.actionLoadingType === 'complete' ? 'Completing...' : 'Complete Trip'), 1)
                                ], 8, _hoisted_24))
                              : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.editingTrip.id !== trip.id)
                      ? _withDirectives((_openBlock(), _createElementBlock("button", {
                          key: 2,
                          type: "button",
                          class: _normalizeClass(Array.isArray(trip.tripNotes) && trip.tripNotes.length > 0
                  ? 'tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-emerald-300 tw-bg-emerald-50 tw-p-1 tw-m-1 tw-text-xs tw-font-semibold tw-text-emerald-700 hover:tw-bg-emerald-100 tw-relative'
                  : 'tw-inline-flex tw-items-center tw-rounded-lg tw-border tw-border-slate-300 tw-bg-slate-100 tw-p-1 tw-m-1 tw-text-xs tw-font-semibold tw-text-slate-900 hover:tw-bg-slate-400 tw-relative'),
                          "aria-label": "View trip notes",
                          onClick: _withModifiers(($event: any) => (_ctx.openTripNotes(trip)), ["stop"])
                        }, [
                          _createVNode(_component_font_awesome_icon, {
                            icon: ['fas', 'sticky-note'],
                            class: _normalizeClass(Array.isArray(trip.tripNotes) && trip.tripNotes.length > 0 ? 'tw-text-emerald-700' : 'tw-text-black')
                          }, null, 8, ["class"]),
                          (Array.isArray(trip.tripNotes) && trip.tripNotes.length > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(trip.tripNotes.length), 1))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_26)), [
                          [_directive_tippy, `View ${trip?.tripNotes?.length} trip note${trip?.tripNotes?.length > 1 ? 's':''}`]
                        ])
                      : _createCommentVNode("", true),
                    (_ctx.editable && _ctx.editingTrip.id !== trip.id)
                      ? (_openBlock(), _createBlock(_component_TripRowActionsMenu, {
                          key: 3,
                          trip: trip,
                          containerId: _ctx.container.id,
                          orderId: _ctx.order.id,
                          isEditing: _ctx.editingTrip.id === trip.id,
                          TRIP_STATUS: _ctx.TRIP_STATUS,
                          canStartTrip: _ctx.caller === 'dispatch' ? _ctx.isNotStartedStatus(trip?.status) : _ctx.canStartTrip(tripIdx),
                          canCompleteTrip: _ctx.caller === 'dispatch' ? _ctx.isInProgressStatus(trip?.status) : _ctx.canCompleteTrip(tripIdx),
                          isActionPending: _ctx.isTripActionPending(trip.id),
                          onEdit: ($event: any) => (_ctx.editTrip(trip)),
                          onAddBefore: ($event: any) => (_ctx.addTripBefore(trip, _ctx.container.id)),
                          onAddAfter: ($event: any) => (_ctx.addTripAfter(trip, _ctx.container.id)),
                          onStartTrip: ($event: any) => (_ctx.startTrip(trip, tripIdx)),
                          onCompleteTrip: ($event: any) => (_ctx.completeTrip(trip, tripIdx)),
                          onRevertTrip: ($event: any) => (_ctx.revertTrip(trip, _ctx.container.id)),
                          onCancelTrip: ($event: any) => (_ctx.cancelTrip(trip)),
                          onSave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveTrip(_ctx.editingTrip))),
                          onCancelEdit: _ctx.cancelEditTrip
                        }, null, 8, ["trip", "containerId", "orderId", "isEditing", "TRIP_STATUS", "canStartTrip", "canCompleteTrip", "isActionPending", "onEdit", "onAddBefore", "onAddAfter", "onStartTrip", "onCompleteTrip", "onRevertTrip", "onCancelTrip", "onCancelEdit"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2),
              (
          _ctx.editable &&
          !_ctx.container.isCancelled &&
          _ctx.tripAdditionContainer === _ctx.container.id &&
          _ctx.editingTrip.afterLegId == tripIdx
        )
                ? (_openBlock(), _createBlock(_component_ContainerAddTripRow, {
                    key: 1,
                    editingTrip: _ctx.editingTrip,
                    onConfirmAddTrip: _cache[8] || (_cache[8] = ($event: any) => (_ctx.confirmAddTrip(_ctx.container, _ctx.order.id))),
                    onCancelTripAddition: _ctx.cancelTripAddition,
                    terminals: _ctx.terminals,
                    filterDrivers: _ctx.filterDrivers,
                    filteredChassis: _ctx.filteredChassis,
                    destinationCustomers: _ctx.destinationCustomers,
                    originCustomers: _ctx.originCustomers,
                    onOnOriginCustomerSearch: _ctx.onOriginCustomerSearch,
                    onOnDestinationCustomerSearch: _ctx.onDestinationCustomerSearch
                  }, null, 8, ["editingTrip", "onCancelTripAddition", "terminals", "filterDrivers", "filteredChassis", "destinationCustomers", "originCustomers", "onOnOriginCustomerSearch", "onOnDestinationCustomerSearch"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_AddNotesModal, {
      open: _ctx.tripNotesModalOpen,
      title: "Trip Notes",
      subtitle: _ctx.selectedTripForNotes ? `Trip #${_ctx.selectedTripForNotes.id}` : undefined,
      trip: _ctx.selectedTripForNotes,
      onClose: _ctx.closeTripNotes,
      onAddedNote: _ctx.updateTripNotes,
      onArchivedNotesUpdated: _ctx.updateTripArchivedNotes
    }, null, 8, ["open", "subtitle", "trip", "onClose", "onAddedNote", "onArchivedNotesUpdated"])
  ]))
}